import ScheduleNoDataEmptyState from './ScheduleNoDataEmptyState';

export default ScheduleNoDataEmptyState;
